"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactNl2br = _interopRequireDefault(require("react-nl2br"));

var _Card = _interopRequireWildcard(require("../Card"));

var _Button = _interopRequireDefault(require("../Button"));

var _config = require("../config/config");

var CardMessage = function CardMessage(_ref) {
  var title = _ref.title,
      positive = _ref.positive,
      negative = _ref.negative,
      negativeShortcut = _ref.negativeShortcut,
      positiveShortcut = _ref.positiveShortcut,
      message = _ref.message,
      onPositive = _ref.onPositive,
      onNegative = _ref.onNegative,
      onClose = _ref.onClose;
  return _react.default.createElement(_Card.default, null, onClose && _react.default.createElement(_Card.CardClose, {
    onClick: onClose
  }), _react.default.createElement(_Card.CardHeader, null, title), message && _react.default.createElement(_Card.CardContent, null, (0, _reactNl2br.default)(message)), _react.default.createElement(_Card.CardActions, null, onNegative && _react.default.createElement(_Button.default, {
    borderless: true,
    shortcut: negativeShortcut || 'esc',
    onClick: onNegative,
    label: negative || (0, _config.__)('Dismiss')
  }), _react.default.createElement(_Button.default, {
    primary: true,
    shortcut: positiveShortcut || 'enter',
    onClick: onPositive,
    label: positive || (0, _config.__)('Ok')
  })));
};

CardMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.node.isRequired,
  message: _propTypes.default.node,
  positive: _propTypes.default.node,
  negative: _propTypes.default.node,
  onPositive: _propTypes.default.func.isRequired,
  onNegative: _propTypes.default.func,
  onClose: _propTypes.default.func
} : {};
var _default = CardMessage;
exports.default = _default;